import { connect } from 'react-redux';
import { State } from '../../../../reducer';
import { withRouter } from 'react-router-dom';
import DiscountsTab from '../components/discountsTab';
import { clearActiveDiscount, getDiscounts, setActiveDiscount } from '../actions';
import { getActiveDiscount, getDiscountsSelector } from '../selectors';

const mapStateToProps = (state: State) => ({
    discounts: getDiscountsSelector(state),
    activeDiscount: getActiveDiscount(state),
});

const mapDispatchToProps = {
    getDiscounts,
    setActiveDiscount,
    clearActiveDiscount,
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(DiscountsTab)
);
